module.exports = __webpack_public_path__ + "img/gish_bus_hurel.c5837169.svg";